import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import PlaceList from './components/PlaceList';
import PlaceDetails from './components/PlaceDetails';

function App() {
    return (
        <Router>
            <Header />
            <Routes>
                <Route path="/" element={<PlaceList />} />
                <Route path="/place/:id" element={<PlaceDetails />} />
            </Routes>
        </Router>
    );
}

export default App;